import { Link } from "react-router-dom";
import useSeo from "../hooks/useSeo";
import seo from "../seo/pages.json";

/** Unknown URL: tells search engines not to index it and offers the real pages. */
export default function NotFound() {
    useSeo({
        title: "Page not found | IDCardGen",
        description: "This page does not exist on IDCardGen.",
        noindex: true,
    });
    const links = seo.pages.filter((p) => p.landing || p.path === "/pricing");

    return (
        <div className="max-w-3xl mx-auto px-6 py-20 text-center" data-testid="not-found-page">
            <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">404</div>
            <h1 className="font-display font-black text-4xl tracking-tighter mt-2">Page not found</h1>
            <p className="text-zinc-600 mt-3">The page you are looking for does not exist or has moved.</p>
            <Link to="/" className="btn-primary inline-block mt-6">
                Go to home page
            </Link>
            <div className="flex flex-wrap justify-center gap-2 mt-10">
                {links.map((p) => (
                    <Link
                        key={p.path}
                        to={p.path}
                        className="border border-zinc-200 bg-white px-4 py-2 text-sm hover:border-violet-400"
                    >
                        {p.title.split(/ [–|] /)[0]}
                    </Link>
                ))}
            </div>
        </div>
    );
}
